export default "__VITE_ASSET__D5jLMQ5m__"